import React from 'react';
import PulseDot from './PulseDot';

const CONFIGS = {
  severity: {
    low:    { text: 'Bajo',  bg: 'rgba(34,197,94,0.1)',   color: '#4ADE80', border: 'rgba(34,197,94,0.25)' },
    medium: { text: 'Medio', bg: 'rgba(251,191,36,0.1)',  color: '#FBBF24', border: 'rgba(251,191,36,0.25)' },
    high:   { text: 'Alto',  bg: 'rgba(220,31,38,0.12)',  color: '#F87171', border: 'rgba(220,31,38,0.3)', pulse: 'red' },
    default:{ text: 'Sin gravedad', bg: 'rgba(255,255,255,0.05)', color: '#6B7391', border: 'rgba(255,255,255,0.1)' },
  },
  type: {
    bug:         { text: 'Bug',   bg: 'rgba(220,31,38,0.12)', color: '#F87171', border: 'rgba(220,31,38,0.3)' },
    improvement: { text: 'Mejora', bg: 'rgba(99,102,241,0.12)', color: '#A5B4FC', border: 'rgba(99,102,241,0.3)' },
    default:     { text: 'Sin tipo', bg: 'rgba(255,255,255,0.05)', color: '#6B7391', border: 'rgba(255,255,255,0.1)' },
  },
  status: {
    open:    { text: 'Abierto', bg: 'rgba(59,130,246,0.12)', color: '#60A5FA', border: 'rgba(59,130,246,0.3)', pulse: 'cyan' },
    closed:  { text: 'Cerrado', bg: 'rgba(255,255,255,0.05)', color: '#6B7391', border: 'rgba(255,255,255,0.1)' },
    default: { text: 'Sin estado', bg: 'rgba(255,255,255,0.05)', color: '#6B7391', border: 'rgba(255,255,255,0.1)' },
  },
};

const Badge = ({ type, value, pulse: forcePulse }) => {
  const typeMap = CONFIGS[type];
  if (!typeMap) return null;
  const config = typeMap[value] || typeMap.default;
  const showPulse = forcePulse || config.pulse;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        padding: '2px 8px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        background: config.bg,
        color: config.color,
        border: `1px solid ${config.border}`,
        letterSpacing: '0.02em',
      }}
    >
      {showPulse && <PulseDot variant={config.pulse || 'cyan'} size={7} />}
      {config.text}
    </span>
  );
};

export default Badge;
